import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "create-an-investigation",
  courseId: "investigations",
  order: 1,
  title: "New investigation",
  subtitle: "Create it and attest privilege",
  summary:
    "An investigation is the container for the jail calls, documents, and photos the AI reads in full. You create it, then attest to privilege handling before any file can be uploaded.",
  learn: [
    "Create an investigation with a focus for the AI",
    "Complete the privilege attestation",
    "Add detectives from your agency",
  ],
  minutes: 3,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "paragraph",
      text: "**Investigations** appears in the sidebar when your department's admin assigns you an Investigator seat. Without one, /investigations shows an upsell page.",
    },
    {
      type: "steps",
      items: [
        "Click **Investigations**, then **New Investigation**.",
        "Fill in Name, Case #, Background, and \"What should the AI focus on?\" (for example \"movement of the firearm; anyone named Marcus; references to the storage unit\").",
        "Click **Create Investigation**.",
        "On the Files tab, drop in your first files. You are asked to attest that privileged communications (attorney calls) will be marked and excluded.",
        "Read the attestation and click **Continue with N files**.",
        "Click \"manage\" next to the members in the header, then **Add from your agency** to bring in other detectives.",
      ],
    },
    {
      type: "paragraph",
      text: "Only members can open the investigation. The attestation is required before anything uploads.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Write a specific focus",
      text: "The focus you type is used in every per-call analysis. Name the people, places, and objects you care about, because the AI uses it to decide what to flag.",
    },
    {
      type: "callout",
      tone: "note",
      text: "Every tab except Files is disabled until the first files finish processing. Brief, Leads, Calls, Mentions, and Timeline fill in as analysis completes.",
    },
    {
      type: "paragraph",
      text: "Upload jail calls is the next step.",
    },
  ],
  related: ["bulk-upload-jail-calls", "work-the-leads-queue"],
};

export default lesson;
